import {priority} from '@priority-software/priority-proto-api/lib';
import {Operator} from '@priority-software/priority-utils/lib/operators';

import {IExtendedCondition, ISearchCondition, ISearchFilter} from '../../types/filters';
import {ApiOperatorMapping, DateApiOperatorMapping} from '../../types/operator';
import {getDateAsMMDDYYYY, getDateStringlocalFormat} from '../../../Form/utils/date';
import {getLang} from '../../../../Localization';
import {getDateRangesMap} from '../../../../common/dateRange';

function buildQuery(filter: ISearchCondition): IExtendedCondition[] {
    const {values, columnID, operator, columnName, origType} = filter;
    const dateRanges = getDateRangesMap();
    let Values = values.map(val =>
        dateRanges[val]
            ? val
            : getDateAsMMDDYYYY(
                  val,
                  origType === priority.netitems.form.ColumnType.Date14,
                  getLang()
              )
    );

    const QueryOperator =
        ApiOperatorMapping[operator] || priority.netitems.shared.ComparisonOperator.Eq;

    if (Operator.NotEmpty === operator || Operator.Empty === operator) {
        Values = [''];
    } else if (Operator.Between !== operator) {
        Values = [Values[0]];
    }

    return [
        {
            Values,
            Operator: QueryOperator,
            ColumnID: columnID,
            ColumnName: columnName
        }
    ];
}

function serialize(condiions: priority.netitems.form.ICondition[]): ISearchFilter {
    const filter = condiions[0];
    const {Values, ColumnID, Operator: queryOperator} = filter;
    const dateRanges = getDateRangesMap();

    return {
        values: Values.map(val =>
            dateRanges[val] ? val : getDateStringlocalFormat(val, getLang())
        ),
        operator: DateApiOperatorMapping[queryOperator],
        columnID: ColumnID
    };
}

export {buildQuery, serialize};
